import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Row, cls } from '../../../packages/components';
import Chunker from './Chunker';
import CardEpisode from './CardEpisode';

class EpisodesList extends Component {
    constructor(props = {}) {
        super(props);
        this.state = {
            episodeNumber: 0,
            episodes: [],
            pbi: props.pbi || [],
            dataAfterBack: props.dataAfterBack
        };
        this.chunker = null;
        // numero de items por columna
        this.quantity = 6;
        this.rightDirection =  'right';
        this.leftDirection =  'left';
        this.lastElement = null;
        this.firstElement = null;
        this.previousCard =  null;
        this.nextCard = null;
    }

    componentDidMount = () => {
        this.addListener();

    };

    getWidth() {
        const width = 100 / (this.quantity - 1) + 4;
        return `${width}%`;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ pbi: nextProps.pbi });
        const {episodes = []} = nextProps;
        if(!nextProps.isBookmarkUpdateOrPBIUpdate) {
            this.chunker = null;
            this.chunker = new Chunker(episodes, this.quantity);
        }
        
        if(this.state.dataAfterBack) {
            let index = nextProps.dataAfterBack.number - nextProps.dataAfterBack.position;
            if(index < 0) {
                index = episodes.length + index;
            }
            this.chunker.setIndex(index);
            this.setState({dataAfterBack: null});
        }
        const episodesList = this.chunker.current() || [];
        this.setData(episodesList);
    }

    setData(episodesList, target = null){
        if (episodesList && episodesList.items && Array.isArray(episodesList.items)) {
            this.setState({episodes: episodesList.items }, () => {
                this.lastElement = episodesList.items[this.quantity-1] || null;
                this.firstElement = episodesList.items[0] || null;

                if(!target){
                    window.SpatialNavigation.makeFocusable();
                }else{
                    const element = document.getElementById(`modal_episode_number_${target}`);

                    if(element){
                        window.SpatialNavigation.focus(element);
                    }
                }
            });
        }
    }

    addListener = () => {
        const x = Array.from(
            document.getElementsByClassName('aaf-main-modal-options-episodes-main')
        );
        if (x && Array.isArray(x) && x[0]) {
            const element = x[0];
            element && typeof element.addEventListener === 'function' && element.addEventListener('sn:focused', this.hasFocused);
        }
    };

    hasFocused = (e) => {
        // Se resetea el scrollLeft del container para que no se mueva al hacer foco.
        // El corrimiento del container solo sucedía en Cajas (Kaon, Huawei, etc...)
        e.target.parentNode.parentNode.scrollLeft = 0;
        if (
            e &&
            e.detail &&
            e.detail.direction &&
            (e.detail.direction === this.rightDirection || e.detail.direction === this.leftDirection)
        ) {
            const target = e && e.target && typeof e.target.getAttribute == 'function' &&  e.target.getAttribute('data-id') || null;
            switch(e.detail.direction){
                case this.rightDirection:
                    this.getRightElements(target);
                    break;
                case this.leftDirection:
                    this.getLeftElements(target);
                    break;
                default:
            }
        }
    };

    getLeftElements = (target) =>{
        if(target && typeof this.firstElement === 'object' && this.firstElement.hasOwnProperty('idx_temp')){
            if(target == this.firstElement.idx_temp){
                this.chunker.setIndex(parseInt(target) - 1);    
                const episodesList = this.chunker.current() || [];
                this.setData(episodesList, target)
            }
        }
    }


    getRightElements = (target) =>{
        if(target && this.lastElement && typeof this.lastElement === 'object' && this.lastElement.hasOwnProperty('idx_temp')){
            if(target == this.lastElement.idx_temp){
                // Obteniedo el primero indice
                if(typeof this.firstElement === 'object' && this.firstElement.hasOwnProperty('idx_temp')){
                    const id = parseInt(this.firstElement.idx_temp) || 0;
                    if(this.chunker && typeof this.chunker.setIndex === 'function'){
                        this.chunker.setIndex(id + 1);
                        const episodesList = this.chunker.current() || [];
                        this.setData(episodesList, target)
                    }
                }
            }
        }
    }

    render() {
        const {episodes = [], pbi = [] } = this.state;
        const { bookmark = [] } = this.props;
        return (
            <Row className={cls(`aaf-main-modal-options-episodes-main`)}>
                {episodes &&
                    Array.isArray(episodes) &&
                    episodes.map((episode) => {
                        let percent = null;
                        let bookMarkByEpisode = null;

                        if(bookmark && Array.isArray(bookmark)){
                            bookMarkByEpisode = bookmark.find( book => book.id === episode.id);
                        }
                        if(bookMarkByEpisode){
                            const {vistime: {last : {progress = null} = {}} = {}} =  bookMarkByEpisode;
                            percent = progress;
                        }
                        return (
                            <CardEpisode
                                episode={episode}
                                width={this.getWidth()}
                                percent ={percent}
                                pbi={pbi[episode && episode.id]}
                                onClick={this.props.onClick || null}
                                key={episode.key}
                            />
                        );
                    })
                }
                {
                    this.nextCard && <CardEpisode episode={this.nextCard} width={`${5}%`} pbi={pbi[episode.id]} isFakeCard={true}/>
                }
            </Row>
        );
    }
}

const mapStateToProps = state => ({
    // user: state.user
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EpisodesList);



// WEBPACK FOOTER //
// ./src/components/EpisodeSelection/components/EpisodesList.jsx